import {IEmploymentInfo} from "@shared/integrations/taf-api/v2/models";

interface IIncomeTableProps {
    employment: IEmploymentInfo;
}
const IncomeTable = ({ employment }: IIncomeTableProps) => {
    return (
        <div className='ft-table ft-flush ft-responsive-sm table-mark-empty font-size-sm'>
            <div className='ft-tbody'>
                <div className='ft-tr'>
                    <div className='ft-th'>Nuvarande inkomst per månad före skatt</div>
                    <div className='ft-td text-right highlight-mask'>{employment.salary} kr</div>
                </div>
            </div>
        </div>
    );
};

export default IncomeTable;
